<template>
  <div 
    class="fts-spinner" 
    :class="[
      {'full-screen-fixed': fullScreen}
    ]" 
    :style="spinnerStyle"
  >
    <canvas
      :width="iconSize"
      :height="iconSize"
      :style="{'height': iconSize + 'px', 'width': iconSize + 'px'}"
      ref="canvas"
      v-if="variantRive"
    ></canvas>
    <svg
      class="spinner"
      viewBox="25 25 50 50"
      :style="{'height': iconSize + 'px', 'width': iconSize + 'px'}"
      v-else
    >
      <circle class="path" fill="none" stroke-width="3" stroke-miterlimit="10" cx="50" cy="50" r="20"></circle>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean, // deprecated
    height: String,
    width: String,
    size: Number,
    variant: String,
    fullScreen: Boolean,  
    boundary: {
      type: String,
      validator: value => ['parent'].indexOf(value) > -1
    }
  },
  data: () => ({
    resizeObserver: null,
    offsetWidth: null
  }),
  computed: {
    variantRive() {
      return this.variant == "rive";
    },
    spinnerStyle() {
      if (this.fullScreen) {
        if (this.boundary === "parent") {
          return {
            "width": `${this.offsetWidth}px`,
            "left": "unset",
            "right": "unset"
          }
        }
      } else {
        return { "height": this.height, "width": this.width };
      }
    },
    iconSize() {
      return this.variantRive ? (this.size || 96) : (this.size || 36);
    }
  },
  mounted() {
    if (this.fullScreen && this.boundary === 'parent') {
      this.resizeObserver = new ResizeObserver(_.debounce((entries) => {
        try {
          const entry = entries.find((x) => x.target === this.$el.parentElement);
          this.offsetWidth = entry.target.offsetWidth;
        } catch(err) {
          console.error(err);
        }
      }));

      this.$nextTick(() => {
        if (this.$el.parentElement && this.$el.parentElement.offsetWidth) {
          this.offsetWidth = this.$el.parentElement.offsetWidth;
        }
        this.resizeObserver.observe(this.$el.parentElement);
      });
    }

    if (this.variantRive) {
      this.$nextTick(() => {
        new rive.Rive({
          src: './pi/rive/inistate-loading.riv',
          canvas: this.$refs.canvas,
          autoplay: true
        });
      });
    }
  },
  beforeDestroy() {
    if (this.fullScreen && this.boundary === 'parent') {
      if (this.resizeObserver) {
        this.$el.parentElement && this.resizeObserver.unobserve(this.$el.parentElement);
        this.resizeObserver.disconnect();
      }
      this.offsetWidth = null;
    }
  }
}
</script>

<style lang="scss">
@use "./src/assets/scss/vars" as *;

.fts-spinner {
  @include flex-center-middle;
  flex-direction: column;
  &.full-screen-fixed {
    position: fixed;
    height: 100%;
    width: 100%;
    inset: 0;
    z-index: $z-index-fixed;
    cursor: wait;
  }
  .spinner {
    $duration: 2s;
    @keyframes rotate {
      100% {
        transform: rotate(360deg);
      }
    }
    @keyframes color {
      0%, 100% {
        stroke: var(--fts-primary);
      }
      40% {
        stroke: var(--fts-ternary-blue);
      }
      66% {
        stroke: var(--fts-ternary-green);
      }
    }
    @keyframes dash {
      0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35px;
      }
      100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124px;
      }
    }
    animation: rotate $duration linear infinite;
    .path {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
      animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
      stroke-linecap: round;
    }
  }
}
</style>